import React, { useContext } from 'react';
import { GameContext } from '../context/GameContext';

const GameSummary = () => {
  const { gameState } = useContext(GameContext);
  const { players, state } = gameState;

  return (
    <div className="bg-white shadow-md rounded p-6 my-6">
      <h2 className="text-xl font-bold text-green-600 mb-4">Game Over</h2>

      <h3 className="text-md font-semibold mb-2">Bases:</h3>
      <ul>
        {Object.entries(state.bases).map(([team, bases]) => (
          <li key={team}>
            Team {team}: <strong>{bases}</strong> base(s)
          </li>
        ))}
      </ul>

      <h3 className="text-md font-semibold mt-4 mb-2">Kodi Counts:</h3>
      <ul>
        {Object.entries(state.kodis || {}).map(([playerId, count]) => {
          const player = players.find(p => p.id === playerId);
          return (
            <li key={playerId}>
              {player?.name || "Unknown"}: <strong>{count}</strong> kodi(s)
            </li>
          );
        })}
      </ul>

      <h3 className="text-md font-semibold mt-4 mb-2">Players:</h3>
      <ul>
        {players.map(p => (
          <li key={p.id}>{p.name} (Team {p.team})</li>
        ))}
      </ul>
    </div>
  );
};

export default GameSummary;
